import { WORDPRESS_API } from "shared/constants/api";

export const projects = [
  {
    id: "erasmus",
    label: "Erasmus+",
    description: "Praktyki zawodowe",
    to: "/projects/erasmus",
    status: "active",
    featured: true,
    showInMenu: true,
    showInFooter: true,
    order: 10
  },
  {
    id: "wklp",
    label: "Wyższe kwalifikacje, lepsze perspektywy",
    description: "CKZiU w Wyrzysku kształci zawodowców",
    to: "/projects/wklp",
    status: "active",
    featured: false,
    showInMenu: false,
    showInFooter: false,
    order: 20
  },
  {
    id: "zdalny-wyrzysk",
    label: "Zdalny Wyrzysk",
    description: "Kształcenie zawodowe w trakcie pandemii",
    to: "/projects/zdalny-wyrzysk",
    status: "archived",
    featured: false,
    showInMenu: false,
    showInFooter: false,
    order: 30
  },
  {
    id: "internship-specialist",
    label: "Od stażysty do specjalisty",
    description: "Projekt rozwoju zawodowego uczniów",
    to: "/projects/od-stazysty-do-specjalisty",
    status: "archived",
    featured: false,
    showInMenu: false,
    showInFooter: false,
    order: 40
  },
  {
    id: "czas-zawodowcow-bis",
    label: "Czas Zawodowców BIS",
    description: "Archiwalny projekt",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/czas-zawodowców-bis.pdf`,
    status: "archived",
    featured: false,
    showInMenu: false,
    showInFooter: false,
    external: true,
    order: 50
  }
];

export const activeProjects = projects
  .filter((project) => project.status === "active")
  .sort((a, b) => a.order - b.order);

export const archivedProjects = projects
  .filter((project) => project.status === "archived")
  .sort((a, b) => a.order - b.order);

export const menuProjects = projects
  .filter(
    (project) =>
      project.status === "active" &&
      project.showInMenu
  )
  .sort((a, b) => a.order - b.order);

export const footerProjects = projects
  .filter(
    (project) =>
      project.status === "active" &&
      project.showInFooter
  )
  .sort((a, b) => a.order - b.order);

export const getProjectById = (projectId) =>
  projects.find(
    (project) => project.id === projectId
  );